import { useAppData } from "../state/AppData";
import { useAuth } from "../state/AuthContext";
import { NAV_DESTINATIONS } from '../lib/definitions/navigation';

// Nav is a curated, small set of real destinations (lib/definitions.ts's
// NAV_DESTINATIONS), each gated on the feature registry rather than being
// generated one-button-per-feature. The
// feature registry says what capabilities exist on the backend — 17+ of
// them, transports and ingest pipelines and observer adapters and auth
// methods included — it was never meant to be rendered 1:1 as nav buttons;
// that produced a two-row wall of internal names nobody actually navigates
// to. A destination is absent, not disabled, when nothing backs it (same
// "never offer what isn't there" rule as everywhere else) — including the
// admin-only Settings destination, hidden here in addition to the page's
// own role guard, per the standing rule that the UI shouldn't even offer a
// control the backend would refuse.
export function Nav({ onSelectDestination }: { onSelectDestination: (route: string) => void }) {
  const { features, featuresError, featuresEverLoaded } = useAppData();
  const { isAdmin } = useAuth();
  const enabledIds = new Set(features.filter((f) => f.enabled).map((f) => f.id));

  if (!featuresEverLoaded && featuresError) {
    return <div className="nav" style={{ color: "var(--ink-muted)", fontSize: 12 }}>Nav unavailable — backend unreachable</div>;
  }

  const visible = NAV_DESTINATIONS.filter((d) => {
    if (d.adminOnly && !isAdmin) return false;
    return d.requiresAnyOf.some((id) => enabledIds.has(id));
  });

  if (featuresEverLoaded && visible.length === 0) {
    return <div className="nav" style={{ color: "var(--ink-muted)", fontSize: 12 }}>No destinations available</div>;
  }

  return (
    <nav className="nav">
      {visible.map((d) => (
        <button key={d.id} className="nav-item" onClick={() => onSelectDestination(d.route)}>
          {d.label}
        </button>
      ))}
    </nav>
  );
}
